module.exports = __webpack_public_path__ + "img/icono_home.310cdeaa.svg";